import { IApplicationState } from '../../types/redux';

export const selectIsSuburbanFlightRkActive = (state: IApplicationState) => {
  return state.dropdown.isSuburbanFlightRkActive;
};
